import gql from 'graphql-tag';

export const weddingWebsiteQuery = gql`
  query wwsOnboardingWeddingWebsiteQuery {
    weddingWebsite {
      id
      searchable
      slug
      source
      state
      userUuid
      weddingUuid
      vanityRoot
      vanityUrl
      themeId
    }
  }
`;
